<div class="ppl-container-body">

  <!-- ── Header ──────────────────────────────────────────────────────────── -->
  <div class="ppl-container-head">
    <div class="details-header">
      <ppl-button label="Back" icon="fa fa-chevron-left" [customClass]="'ghost-button'" iconPosition="left"
        (click)="goBack()"></ppl-button>
      <h3 class="page-title-accessibility">
        {{ isViewMode ? 'Payroll Batch ' + batchInstanceId : 'New Payroll Processing' }}
      </h3>
    </div>
    <div class="action" *ngIf="!isViewMode">
      <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'ghost-button'" [iconPosition]="'left'"
        [styleString]="'margin-right: 8px;'" (click)="onCancel()">
      </ppl-button>
      <ppl-button label="Create Batch" icon="fa fa-floppy-o" [customClass]="'primary-button'" [iconPosition]="'left'"
        [disabled]="!canSubmit" (click)="onSave()">
      </ppl-button>
    </div>
  </div>

  <!-- ── Body ────────────────────────────────────────────────────────────── -->
  <div class="ppl-container">
    <div class="ppl-content-container body-scroll">

      <!-- Batch summary, shown only for an existing batch -->
      <ppl-accordion *ngIf="isViewMode" [title]="'Batch Information'" [isOpen]="true">
        <div class="wiz-body">
          <dl class="details-grid">
            <div class="details-item">
              <dt>Batch ID</dt>
              <dd>{{ batchInstanceId || '—' }}</dd>
            </div>
            <div class="details-item">
              <dt>Batch Type</dt>
              <dd>{{ batchRow?.batchType || '—' }}</dd>
            </div>
            <div class="details-item">
              <dt>Batch Process</dt>
              <dd>{{ batchRow?.batchProcess || '—' }}</dd>
            </div>
            <div class="details-item">
              <dt>Status</dt>
              <dd>{{ batchRow?.batchStatus || '—' }}</dd>
            </div>
            <div class="details-item">
              <dt>Modified By</dt>
              <dd>{{ batchRow?.modifiedByName || '—' }}{{ batchRow?.modifiedDate ? ' on ' + batchRow.modifiedDate : '' }}</dd>
            </div>
          </dl>
        </div>
      </ppl-accordion>

      <ppl-accordion [title]="'Batch Criteria'" [isOpen]="true">
        <div class="wiz-body">

          <!-- Existing batch: criteria are fixed once the batch is created -->
          <ng-container *ngIf="isViewMode">
            <table class="criteria-table read-only" *ngIf="criteriaFormArray.length > 0; else noCriteria">
              <thead>
                <tr>
                  <th class="col-field">Column</th>
                  <th class="col-field">Operator</th>
                  <th class="col-field">Value</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of criteriaFormArray.controls">
                  <td class="cell">{{ criteriaColumnLabel(row.get('columnLkp')?.value) }}</td>
                  <td class="cell">{{ operatorLabel(row.get('operatorLkp')?.value) || '—' }}</td>
                  <td class="cell">
                    {{ row.get('value')?.value || '—' }}<ng-container
                      *ngIf="isBetweenRow(row) && row.get('valueEnd')?.value"> – {{ row.get('valueEnd')?.value }}</ng-container>
                  </td>
                </tr>
              </tbody>
            </table>
            <ng-template #noCriteria>
              <p class="section-hint">No criteria were recorded for this batch.</p>
            </ng-template>
          </ng-container>

          <!-- New batch: build the criteria -->
          <form *ngIf="!isViewMode" nz-row [formGroup]="batchForm" class="ppl-p0">
            <div class="input-section batch-type-row">
              <div class="batch-type-field">
                <label for="batchType"><strong>Batch Type<span class="required-marker"> *</span></strong></label>
                <ppl-dropdown-select id="batchType" formControlName="batchType" class="ppl-select"
                  [options]="batchTypeOptions" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                  [placeholder]="'Select Batch Type'">
                </ppl-dropdown-select>
                <small class="validation-error"
                  *ngIf="batchForm.get('batchType')?.invalid && batchForm.get('batchType')?.touched">
                  Batch Type is required
                </small>
              </div>
              <div class="batch-type-field">
                <label for="dataType"><strong>Data Type<span class="required-marker"> *</span></strong></label>
                <ppl-dropdown-select id="dataType" formControlName="dataType" class="ppl-select"
                  [options]="dataTypeOptions" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                  [placeholder]="'Select Data Type'">
                </ppl-dropdown-select>
                <small class="validation-error"
                  *ngIf="batchForm.get('dataType')?.invalid && batchForm.get('dataType')?.touched">
                  Data Type is required
                </small>
              </div>
            </div>

            <div class="input-section batch-type-row">
              <div class="batch-type-field">
                <label for="checkDate"><strong>Check Date<span class="required-marker"> *</span></strong></label>
                <nz-date-picker id="checkDate" formControlName="checkDate" class="full-width"
                  [nzFormat]="'MM/dd/yyyy'" [nzPlaceHolder]="'MM/dd/yyyy'"
                  [nzDisabledDate]="disabledCheckDate">
                </nz-date-picker>
                <small class="validation-error"
                  *ngIf="batchForm.get('checkDate')?.errors?.['required'] && batchForm.get('checkDate')?.touched">
                  Check Date is required
                </small>
                <small class="validation-error"
                  *ngIf="batchForm.get('checkDate')?.errors?.['pastDate'] && batchForm.get('checkDate')?.touched">
                  Check Date cannot be in the past
                </small>
              </div>
              <div class="batch-type-field">
                <label for="providerType"><strong>Provider Type</strong></label>
                <ppl-dropdown-select id="providerType" formControlName="providerType" class="ppl-select"
                  [options]="providerTypeOptions" [optionLabel]="'name'" [optionValue]="'code'"
                  [placeholder]="'Select Provider Type'">
                </ppl-dropdown-select>
              </div>
            </div>

            <div class="input-section">
              <div class="section-label-row">
                <p class="section-hint">
                  Criteria select which timesheets the batch picks up. At least one is required.
                </p>
                <ppl-button label="Add Criteria" icon="fa fa-plus" [customClass]="'ghost-button'" iconPosition="left"
                  (click)="addCriteriaRow()"></ppl-button>
              </div>

              <ng-container *ngIf="criteriaFormArray.controls.length > 0">
                <div formArrayName="criteria" class="table-wrapper">
                  <table class="criteria-table">
                    <thead>
                      <tr>
                        <th class="col-field">Column</th>
                        <th class="col-field">Operator</th>
                        <th class="col-field">Value</th>                        
                        <th class="col-actions">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of criteriaFormArray.controls; let i = index" [formGroupName]="i">
                        <td class="cell">
                          <ppl-dropdown-select formControlName="columnLkp" class="ppl-select"
                            [options]="criteriaColumns" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                            [placeholder]="'Select Column'">
                          </ppl-dropdown-select>
                          <small class="validation-error"
                            *ngIf="row.get('columnLkp')?.invalid && row.get('columnLkp')?.touched">
                            Column is required
                          </small>
                        </td>
                        <td class="cell">
                          <ppl-dropdown-select formControlName="operatorLkp" class="ppl-select"
                            [options]="operatorOptions" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                            [placeholder]="'Select Operator'">
                          </ppl-dropdown-select>
                          <small class="validation-error"
                            *ngIf="row.get('operatorLkp')?.invalid && row.get('operatorLkp')?.touched">
                            Operator is required
                          </small>
                        </td>
                        <td class="cell">
                          <!-- Between takes a range, so its two bounds sit side by side -->
                          <div class="value-range">
                            <div class="value-range-field">
                              <ppl-dropdown-select *ngIf="valueOptionsFor(row) as valueOptions; else freeTextValue"
                                formControlName="value" class="ppl-select"
                                [options]="valueOptions" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                                [placeholder]="'Select Value'">
                              </ppl-dropdown-select>
                              <ng-template #freeTextValue>
                                <input nz-input formControlName="value"
                                  [placeholder]="isBetweenRow(row) ? 'From(MM/dd/yyyy)' : 'Enter Value'" class="full-width" />
                              </ng-template>
                              <small class="validation-error"
                                *ngIf="row.get('value')?.invalid && row.get('value')?.touched">
                                Value is required
                              </small>
                            </div>

                            <div class="value-range-field" *ngIf="isBetweenRow(row)">
                              <input nz-input formControlName="valueEnd" placeholder="To(MM/dd/yyyy)" class="full-width" />
                              <small class="validation-error"
                                *ngIf="row.get('valueEnd')?.invalid && row.get('valueEnd')?.touched">
                                End Value is required
                              </small>
                            </div>
                          </div>
                        </td>
                        <td class="cell cell-actions">
                          <button pButton type="button" icon="pi pi-plus-circle"
                            class="p-button-rounded p-button-text p-button-sm action-btn"
                            (click)="addCriteriaRow(i)"></button>
                          <button pButton type="button" icon="pi pi-trash"
                            class="p-button-rounded p-button-text p-button-sm action-btn-danger"
                            [disabled]="criteriaFormArray.length === 1"
                            (click)="removeCriteriaRow(i)"></button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ng-container>
            </div>
          </form>
        </div>
      </ppl-accordion>
    </div>
  </div>
</div>
